<template>
  <MDropdown ref="dropdownMenu">
    <template v-slot:trigger>
      <MButton
        id="action-btn"
        variant="neutral-lighter"
        :shadow="false"
        shape="circle"
      >
        <MIcon name="ellipsis-v" size="2x" />
      </MButton>
    </template>
    <template v-slot:menu>
      <MMenu class="action-menu">
        <MMenuItem v-if="kb.canEdit && kb.status !== 'expired'">
          <ApprovalAction
            :module-name="moduleName"
            :parent-id="kb.id"
            :resource-name="kb.name"
            @trigger="hide"
            @done="$emit('approval-changed')"
          />
        </MMenuItem>
        <MMenuItem
          v-if="
            !disabled &&
            kb.status === 'draft' &&
            kb.approvalStatus !== 'pre_approved' &&
            kb.status !== 'expired'
          "
        >
          <ApprovalDetailsDrawer
            :use-icon="true"
            :module-name="moduleName"
            :kb="kb"
            @trigger="hide"
            @done="$emit('approval-changed')"
          />
        </MMenuItem>
        <MMenuItem v-if="!disabled">
          <RelationAction
            :module-name="$constants.KNOWLEDGE"
            :resource-id="kb.id"
            disabled
            :use-icon="true"
            :excluded-modules="[$constants.KNOWLEDGE]"
            @trigger="hide"
          />
        </MMenuItem>
        <MMenuItem>
          <AuditAction
            :module-name="$constants.KNOWLEDGE"
            :resource-id="kb.id"
            :use-icon="true"
            @trigger="hide"
          />
        </MMenuItem>
        <MMenuItem v-if="false">
          <Print @done="hide" />
        </MMenuItem>
      </MMenu>
    </template>
  </MDropdown>
</template>

<script>
import AuditAction from '@components/audit/audit-action-menu-item'
import RelationAction from '@components/relation/relation-action-menu-item'
import ApprovalAction from '@components/approval/approval-action'
import ApprovalDetailsDrawer from '../components/approval-details-drawer'

export default {
  name: 'ActionMenu',
  components: {
    AuditAction,
    RelationAction,
    ApprovalAction,
    ApprovalDetailsDrawer,
  },
  props: {
    kb: { type: Object, required: true },
    moduleName: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    hide() {
      this.$refs.dropdownMenu.hide()
    },
  },
}
</script>
